import React, {useState, useEffect} from "react";
import { Container, Row, Col, Card, Nav, Tabs, Tab } from "react-bootstrap";
import styles from "./Status.module.css";
import { FaUsers } from "react-icons/fa";
import NewHeader from "../../Components/NewHeader";
import Cash from "../../assetss-header/Frame 265.png"
import Pot from "../../assetss-header/Frame 267.png"
import Red from "../../assetss-header/Frame 125 (2).png"
import Orange from "../../assetss-header/Frame 125 (1).png"
import Green from "../../assetss-header/Frame 125.png"



export default function ApplicationStatus() {
  return (
    <div>
    <NewHeader />
    <div  className={styles.wrapper}>
      {/* HEADER */}
      <div className={styles.headerSection}>
        <div className={styles.titleRow}>
          <span className={styles.dash}></span>
          <h4>Application Status</h4>
        </div>
        <p className={styles.subtitle}>
          Track the progress of all your welfare programme applications
        </p>
      </div>

      {/* METRIC CARDS */}
      <Row className={styles.metricRow}>
        {[ 
          { count: 2, text: "Total Application(s)", color: "green", images: Green },
          { count: 1, text: "Under Review", color: "orange", images: Orange },
          { count: 1, text: "Approved Application(s)", color: "green", images: Green },
          { count: 0, text: "Rejected Application(s)", color: "red", images: Red },
        ].map((item, index) => (
          <Col xs={12} md={6} lg={3} key={index} className="mb-3">
            <div className={`${styles.metricCard} ${styles[item.color]}`}>
              <div 
              className={styles.iconBox}
              >
                <img src={item.images} alt="User Icon" width={50} height={50} />
              </div>
              <div className={styles.metd}>
                <h5>{item.count}</h5>
                <span>{item.text}</span>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {/* TABS */}
      <Tabs
        defaultActiveKey="all"
        className={`border-bottom-0 ${styles.tabs}`}
        mountOnEnter
        unmountOnExit
      >
        {/* ALL TAB (WITH CONTENT) */}
        <Tab
          eventKey="all"
          title={<span className={`${styles.tab} ${styles.active}`}>All</span>}
        >
          <Row className="mt-4">

            {/* CARD 1 */}
            <Col xs={12} lg={6} className="mb-4">
              <Card className={styles.appCard}>
                <div className={styles.cardHeader}>
                  <div className={styles.flexlay}>
                  <div>
                    <img src={Cash} alt="Cash" width={50} height={50} />
                  </div>
                  <div className={styles.cadHd} >
                    <h6>Cash Transfer</h6>
                    <small>Application ID: OG-APP-2026-00231</small>
                  </div>
                  </div>
                  <span className={styles.badgeOrange}>Under Review</span>
                </div>

                <hr className={styles.border} />

                <div className={styles.activityLog}>
                  <h6>ACTIVITY LOG</h6>

                  {/* ITEM 1 */}
                  <div className={styles.logItem}>
                    <div className={styles.timeline}>
                      <span className={styles.dotGreens}></span>
                      <span className={styles.lines}></span>
                    </div>

                    <div className={styles.cardtexts}>
                      <strong>Application Submitted</strong>
                      <p>Feb 15, 2026 - 10:24 AM</p>
                    </div>
                  </div>

                  {/* ITEM 2 */}
                  <div className={styles.logItem}>
                    <div className={styles.timeline}>
                      <span className={styles.dotOranges}></span>
                    </div>

                    <div className={styles.cardtexts1} >
                      <strong>Assigned to LGA Officer — Abeokuta South</strong>
                      <p>Feb 15, 2026 - 10:24 AM</p>
                    </div>
                  </div>
                </div>

                <div className={styles.noticeBox}>
                  Your application is being reviewed by the LGA officer. You will be notified once a decision is made
                </div>
              </Card>
            </Col>

            {/* CARD 2 */}
            <Col xs={12} lg={6} className="mb-4">
              <Card className={styles.appCard}>
                <div className={styles.cardHeader}>
                <div className={styles.flexlay}>
                <div>
                    <img src={Pot} alt="Cash"  width={50} height={50} />
                  </div>
                  <div className={styles.cadHd}>
                    <h6>Food Support</h6>
                    <small>Application ID: OG-APP-2026-00198</small>
                  </div>
                  </div>
                  <span className={styles.badgeGreen}>Approved</span>
                </div>

                <hr className={styles.border} />

                <div className={styles.activityLog}>
                  <h6>ACTIVITY LOG</h6>

                  {/* ITEM 1 */}
                  <div className={styles.logItem}>
                    
                    <div className={styles.timeline}>
                      <span className={styles.dotGreen1}></span>
                      <span className={styles.line1}></span>
                    </div>

                    <div className={styles.cardtexts}>
                      <strong>Application Submitted</strong>
                      <p>Feb 14, 2026 - 2:10 PM</p>
                    </div>
                  </div>

                  {/* ITEM 2 */}
                  <div className={styles.logItem}>
                    <div className={styles.timeline}>
                      <span className={styles.dotGreen}></span>
                      <span className={styles.line1}></span>
                    </div>

                    <div className={styles.cardtexts} style={{marginTop: "-7px"}}>
                      <strong style={{marginTop: "-10px"}}>Reviewed by LGA Officer</strong>
                      <p>Feb 17, 2026 - 11:30 AM</p>
                    </div>
                  </div>

                  {/* ITEM 3 */}
                  <div className={styles.logItem}>
                    <div className={styles.timeline}>
                      <span className={styles.dotGreen}></span>
                    </div>

                    <div className={styles.cardtexts} style={{marginTop: "-8px"}}>
                      <strong>
                        Application approved — delivery begins April 2026
                      </strong>
                      <p>Feb 20, 2026 - 8:45 AM</p>
                    </div>
                  </div>
                </div>

                <div className={styles.noticeSuccess}>
                  Your application has been approved. Food support delivery is scheduled to begin April 2026. You will be contacted by your field agent with collection details
                </div>
              </Card>
            </Col>

          </Row>
        </Tab>

        {/* EMPTY TABS */}
        <Tab eventKey="underReview" title={<span className={styles.tab}>Under Review</span>} />
        <Tab eventKey="approved" title={<span className={styles.tab}>Approved</span>} />
        <Tab eventKey="rejected" title={<span className={styles.tab}>Rejected</span>} />

      </Tabs>
    </div>
    </div>
  );
}